import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { checkIsMemberAStripeCustomer } from 'features/giving/givingSlice'
import styled from 'styled-components'
import GiveToChurch from './GiveToChurch'
import { useNavigate, useLocation } from 'react-router-dom'
import Loader from 'loaders/Loader'
import { GivingButton } from './giving.styled'
import Campaigns from './campaigns/Campaigns'
import { setViewCreateGivingCampaignModal } from 'features/givingCampaigns/givingCampaignSlice'
import { Modal } from '@mui/material'
import CreateCampaignModal from './campaigns/CreateCampaignModal'
import { BiDonateHeart } from "react-icons/bi";
import { TbActivityHeartbeat } from "react-icons/tb";
import { IoMdAdd } from "react-icons/io";
import { useTranslation } from 'react-i18next'


export default function Giving() {
    const { t } = useTranslation('giving')
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { user } = useSelector((state) => state.auth)
    const { profileChurch } = useSelector((state) => state.profileChurch)
    const { viewCreateGivingCampaignModal } = useSelector((state) => state.givingCampaign)

    const view = new URLSearchParams(location.search).get('v') ? new URLSearchParams(location.search).get('v') : 'none'

    const {  
        isCustomer,  
        checkIsMemberAStripeCustomerError,
        checkIsMemberAStripeCustomerSuccess,
        checkIsMemberAStripeCustomerLoading,
        createGivingCampaignSuccess,
        createGivingCampaignError
     } = useSelector((state) => state.giving)

    const handleCreateCampaign = () => {
        dispatch(setViewCreateGivingCampaignModal(true))
    }

    useEffect(() => { 
        if(!user.isOrganization){
            dispatch(checkIsMemberAStripeCustomer({ churchId: profileChurch._id })) 
        }     
    }, [])

    const handleCreateCustomer = () => {
        console.log('creating customer')
    }

    const handleView = (value) => { 
        if(value === 'give'){
            navigate('?section=giving&v=give&status=initialize')
        }else{
            navigate(`?section=giving&v=${value}`) 
        } 
    }

    useEffect(() => { 
        if(!view || view === 'none'){
            navigate('?section=giving&v=campaigns')
        }else if(view === 'transactions' || view === 'payment-methods'){
            navigate(`/settings?section=giving&view=${view}`)
        }  
    }, [view, navigate])
    

    if(checkIsMemberAStripeCustomerError){
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100px',
                    width: '100%',
                    color: 'grey'
                }}
                >
                    {checkIsMemberAStripeCustomerError}
            </div>
        )
    }else{ 

        return (
            <MediaPageContainer>
                <ButtonWrap> 
                    {
                        checkIsMemberAStripeCustomerLoading ? (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: '100px',
                                    width: '100%'
                                }}
                                >
                                <Loader />
                            </div>
                            
                        )
                        :  checkIsMemberAStripeCustomerError ? 
                        (
                            <GivingButton
                            // active={true}
                                onClick={handleCreateCustomer}

                            >
                                {t('startGivingTo', { church: profileChurch.fullName })}
                            </GivingButton>
                        )
                        : isCustomer && !user.isOrganization ?
                        (
                            <GivingTop>
                                <ViewBtns>
                                    <GivingButton
                                        active={view === 'give'}
                                        onClick={() => handleView('give')}
                                        >
                                        <BiDonateHeart style={{  fontSize: '20px' }} />
                                        <span>{t('form.giveNow')}</span>
                                    </GivingButton>
                                    <GivingButton
                                        active={view === 'campaigns'}
                                        onClick={() => handleView('campaigns')}
                                        >
                                        <TbActivityHeartbeat style={{ fontSize: '20px' }} />
                                        <span>{t('campaigns.title')}</span>
                                    </GivingButton> 
                                </ViewBtns>
                            </GivingTop>
                        )
                        : user.isOrganization &&  
                        (
                            <span style={{display: "flex", flexDirection: "row", gap: "10px"}}>
                                <GivingButton
                                    active={view === 'campaigns'}
                                    onClick={() => handleView('campaigns')}
                                    >
                                    <TbActivityHeartbeat style={{ fontSize: '20px' }} />
                                    <span>{t('campaigns.title')}</span>
                                </GivingButton>    

                                <GivingButton 
                                    onClick={handleCreateCampaign}
                                    >
                                    <IoMdAdd style={{ fontSize: '20px' }} />
                                    <span>{t('campaigns.create')}</span>
                                </GivingButton> 
                            </span> 
                        )
                    } 
                </ButtonWrap>
    

                {
                    !checkIsMemberAStripeCustomerError && !checkIsMemberAStripeCustomerLoading && (
                        view === 'give' ? 
                        ( 
                            <GiveToChurch />
                        )
                        : view === 'campaigns' ?
                        (
                            <Campaigns />
                        )
                        : null
                    )
                } 

                <Modal
                    open={viewCreateGivingCampaignModal}
                    onClose={() => dispatch(setViewCreateGivingCampaignModal(false))}
                    >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '99vw',
                            height: '99vh', 
                        
                        }}
                        >
                            <CreateCampaignModal />

                    </div>
                </Modal> 
            </MediaPageContainer>
        )
    }
}

const ViewBtns = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    width: 100%;
    height: 100%; 
`

const GivingTop = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center; 
`

const MediaPageContainer = styled.div`
    height: 100%;
    padding: 10px;
`
const ButtonWrap = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;  

`
